import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';
import {
  ExportInterface,
  FscsExportRequest,
  FscsExportsResponse
} from '@interfaces/Export.interface';

export class ApiExport extends BaseApiClient {
  /**
   * Gets list of job titles
   */
  async listExport(
    type: string,
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<ExportInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.uuid = searchTerm;
      }
      this.client
        .getList(`/export/${type}`, listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async create(
    type: string,
    filters?: { [key: string]: unknown },
    sort?: { [key: string]: unknown } | string,
    entityId?: number
  ): Promise<ExportInterface> {
    return new Promise((resolve, reject) => {
      const url =
        typeof entityId === 'number'
          ? `/export/${type}/${entityId}`
          : `/export/${type}`;

      this.client
        .post(url, {
          filter: filters,
          sort: sort || null
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async createFscs({
    savingsBankId,
    reportDate
  }: FscsExportRequest): Promise<FscsExportsResponse> {
    const response = await this.client.post('/fscs-exports', {
      filter: {
        savings_bank_id: savingsBankId,
        report_date: reportDate
      }
    });

    if (!response.data) throw new Error('Invalid response');
    return response.data;
  }

  async download(exportId: number) {
    return this.client.get(`/export/download/${exportId}`);
  }
}

export { exportQueryKeys } from './query-keys';
export type { ExportListQueryParams } from './query-keys';
export { useExportListQuery } from './use-export-queries';
export {
  useExportCreateMutation,
  useFscsExportCreateMutation,
  useExportDownloadMutation
} from './use-export-mutations';
export type {
  ExportCreateVariables,
  FscsExportCreateVariables
} from './use-export-mutations';
